import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { AppProvider } from "./state/AppContext";
import { AuthProvider } from "./state/AuthContext";
import { ImpersonationProvider } from "./state/ImpersonationContext";
import { ToastProvider } from "./components/ui/Toast";
import { applyTheme, clearLegacyThemeStorage } from "./lib/theme";

// Phase 7.0 S3 — Inter + Inter Display are self-hosted via @font-face
// in styles/globals.css (woff2 under /public/fonts/). The old Lato +
// Source Serif 4 fontsource imports are gone (Inter replaces both the
// body sans and the heading face). JetBrains Mono stays for .text-mono.
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

import "./styles/globals.css";

// Apply the (single) Slack theme synchronously before React renders so
// the first paint already has the dark palette in place. Then prune
// the legacy `slack-archive-viewer:theme` localStorage key written by
// pre-Pass-2.10 builds — Pass 2.10 removed the toggle.
applyTheme();
clearLegacyThemeStorage();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Missing #root element in index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ImpersonationProvider>
          <ToastProvider>
            <AppProvider>
              <App />
            </AppProvider>
          </ToastProvider>
        </ImpersonationProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
